<template>
  <v-app
    :style="{'background-color' : (isMobile ? '#ffffff !important': '#f2f3f7')}"
    :class="[$root.$i18n.locale != 'fa' ? 'body-font-' + $root.$i18n.locale : '',
             'white-back' ? isMobile : false ,
             $store.state.iranSansEnNum === 'active' ? 'iran-sans-en-num' : '',
             'grey-back' ? !isMobile : false]"
  >
    <span
      :style="{
        'background-image': ($store.state.backgroundImage ? 'url(' + $store.state.backgroundImage + ')' : ''),
        'background-color': ($store.state.backgroundColor && !$store.state.backgroundImage ? $store.state.backgroundColor : false),
      }"
      :class="{'bg' : $route.path == '/', 'bg-blur' : $route.path !== '/'}"
    />
    <v-overlay
      :opacity="1"
      :value="overlay"
      color="#fff"
      style="z-index: 10"
    >
      <v-img
        v-if="$brand === 'abriron'"
        width="80"
        src="@/assets/abriron.png"
      />
      <v-img
        v-if="$brand !== 'abriron'"
        width="80"
        class="pt-3 px-2"
        :src="logoBrand"
      />
      <v-progress-linear
        color="primary"
        indeterminate
        height="4"
      >
      </v-progress-linear>
    </v-overlay>
    <dashboard-core-app-bar />

    <!--    <dashboard-core-drawer />-->
    <dashboard-core-drawer-hover
      v-if="hoverMenu && !isMobile"
    />
    <dashboard-core-drawer-hover v-if="isMobile" />
    <dashboard-core-drawer-permanent
      v-if="!hoverMenu && !isMobile"
    />

    <dashboard-core-view />
    <dashboard-footer v-if="isMobile && $store.state.bottomNavigate" />
    <div
      ref="refAutoPrint"
      style="display: none"
    >
      <div v-if="$store.state.invoiceData">
        <index-print
          :account-prop="$store.state.invoiceData.customer"
          :date-prop="$store.state.invoiceData.date"
          :items-prop="$store.state.invoiceData.article"
          :sum-prop="$store.state.invoiceData.price.price"
          :total-discount="$store.state.invoiceData.discount"
          :total-tax="$store.state.invoiceData.tax"
          :id-prop="$store.state.invoiceData.id"
          :number-prop="$store.state.invoiceData.number"
          :status-prop="printStatus"
          :content-prop="$store.state.invoiceData.content"
        />
      </div>
    </div>
  </v-app>
</template>

<script>
  import indexPrint from './pages/invoice/indexCategoryPrint.vue'
  export default {
    name: 'DashboardIndex',
    components: {
      indexPrint,
      DashboardCoreAppBar: () => import('./components/core/AppBar'),
      DashboardFooter: () => import('./components/core/Footer'),
      DashboardCoreDrawerHover: () => import('./components/core/DrawerHover'),
      DashboardCoreDrawerPermanent: () => import('./components/core/DrawerPermanent'),
      // DashboardCoreSettings: () => import('./components/core/Settings'),
      DashboardCoreView: () => import('./components/core/View'),
    },
    data: () => ({
      expandOnHover: false,
      menu: false,
      overlay: true,
      allowScale: true,
      printStatus: 'print',
    }),
    sockets: {
      connect: async function () {
        var app = this
        var local = localStorage.getItem('token')
        const response = await fetch('https://api.ipify.org/?format=json')
        const res = await response.json()
        this.$store.commit('SET_USERID', JSON.parse(local).init.userId)
        var data = {
          userId: JSON.parse(local).init.userId,
          userName: localStorage.getItem('fullname'),
          abrKey: localStorage.getItem('APP_KEY'),
          ip: res.ip,
          browser: this.$browserDetect,
        }
        app.$socket.emit('live', JSON.stringify(data))
      },
      forceLogout: function (data) {
        this.logout()
      },
      printInvoice: function (data) {
        if (data.type === 'kitchen') {
          this.getInvoice(data.invoiceUID)
        }
      },
    },
    computed: {
      hoverMenu: {
        get () {
          return this.$store.state.hoverMenu
        },
        set (val) {
          this.$store.commit('SET_HOVERMENU', val)
        },
      },
      invoiceData: {
        get () {
          return this.$store.state.invoiceData
        },
        set (val) {
          this.$store.commit('SET_INVOICEDATA', val)
        },
      },
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
    },
    watch: {
      hoverMenu () {
      },
      invoiceData (val) {
        if (val) {
          var app = this
          setTimeout(function () {
            var data = {
              body: app.$refs.refAutoPrint.innerHTML,
            }
            app.autoPrintInvoice(data)
          }, 500)
        }
      },
    },
    mounted () {
      var app = this
      setTimeout(function () {
        app.overlay = false
      }, 3000)
    },
    methods: {
    },
  }
</script>

<style scoped>
.v-form {
  zoom: 0.9;
}
.body-font-en{
  font-family: sans-serif !important;
}
.body-font-ku{
  font-family: NRT !important;
}
.theme--light.v-application {
  background: #f1f1f1 !important;
}
.bg {
  width: 100vw;
  height: calc(100vh);
  /*height: 100%;*/
  background-repeat: repeat-y;
  position: fixed;
  top: 0;
  left: 0;
  -webkit-mask-image:-webkit-gradient(linear, left top, left bottom, from(rgba(0,0,0,1)), to(rgba(0,0,0,0)));
  mask-image: linear-gradient(to bottom, rgba(0,0,0,1) 65%, rgba(0,0,0,0));
  /*background: url('../../assets/lock.jpg');*/
  background-size: cover;
  /*background-color: #f1f1f1;*/
  transform: scale(1);
}

.bg-blur {
  width: 100vw;
  height: calc(100vh);
  background-repeat: repeat-y;
  position: fixed;
  /*filter: blur(1px);*/
  /*opacity: 0.1;*/
  /*-webkit-filter: blur(2px);*/
  -webkit-mask-image:-webkit-gradient(linear, left top, left bottom, from(rgba(0,0,0,1)), to(rgba(0,0,0,0)));
  mask-image: linear-gradient(to bottom, rgba(0,0,0,1), rgba(0,0,0,0));
  top: 0;
  left: 0;
  background: url('../../assets/lock.jpg');
  background-size: cover;
  /*background-color: #ffffff;*/
  transform: scale(1);
}
.white-back {
  background-color: #ffffff !important;
}
.grey-back {
  background-color: #f2f3f7 !important;
}
.iran-sans-en-num {
  font-family: IRANSansEn !important;
  font-size: 12px !important;
}
</style>
